import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

const VehicleAdvanceFilter = ({
  filters,
  onFilterChange,
  onFind,
  onReset,
  vehicles,
  loading,
}) => {
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);
  const findBtnRef = useRef(null);
  const resetBtnRef = useRef(null);
  const handleInputChange = (name, value) => {
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
    onFilterChange(name, value);
  };

  const handleKeyDown = (e, nextRef, action) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (typeof action === "function") {
        action();
      }

      nextRef?.current?.focus();
    }
  };

  return (
    <Form className="vendor-advance-filter-form">
      <Row>
        <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
          <div className="dropdown-label">Date</div>
          <Form.Control
            type="date"
            value={localFilters.date || ""}
            onChange={(e) => handleInputChange("date", e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, findBtnRef, onFind)}
          />
        </Form.Group>

        <Col className="d-flex justify-content-end align-items-center">
          <Button
            variant="primary"
            className="me-2"
            onClick={onFind}
            ref={findBtnRef}
            onKeyDown={(e) => handleKeyDown(e, resetBtnRef, onFind)}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Finding..
              </>
            ) : (
              "Find"
            )}
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              onReset();
              setLocalFilters({ date: "" });
            }}
            ref={resetBtnRef}
            onKeyDown={(e) =>
              handleKeyDown(e, null, () => {
                onReset();
                setLocalFilters({ date: "" });
              })
            }
          >
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default VehicleAdvanceFilter;
